import { render } from "./klasse.vue?vue&type=template&id=5ec30bfe&scoped=true"
import script from "./klasse.vue?vue&type=script&lang=js"
export * from "./klasse.vue?vue&type=script&lang=js"

import "./klasse.vue?vue&type=style&index=0&id=5ec30bfe&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ec30bfe"]])

export default __exports__